import React from 'react';
import { Brain, Calendar, FileSearch, Files, Utensils } from 'lucide-react';
import { useDocumentMetadata } from '../hooks/useDocumentMetadata';

const services = [
  {
    icon: <FileSearch className="h-6 w-6 text-sky-600" />,
    title: 'AI Imaging Analysis',
    description:
      'Upload X-rays and supporting PDFs to receive structured diagnostic summaries and recommended actions.',
  },
  {
    icon: <Utensils className="h-6 w-6 text-sky-600" />,
    title: 'Personalized Wellness Planning',
    description:
      'Generate nutrition and sleep plans tailored to activity level, restrictions, and recovery goals.',
  },
  {
    icon: <Calendar className="h-6 w-6 text-sky-600" />,
    title: 'Appointment Intake',
    description:
      'Capture provider preferences, visit reasons, and contact details in a patient-friendly scheduling flow.',
  },
  {
    icon: <Brain className="h-6 w-6 text-sky-600" />,
    title: 'Mental Wellness Chat',
    description:
      'Offer immediate, empathetic support conversations that complement broader care programs.',
  },
  {
    icon: <Files className="h-6 w-6 text-sky-600" />,
    title: 'Document QA with Citations',
    description:
      'Index PDFs or TXT files locally, retrieve relevant chunks, and answer questions through a grounded Groq-powered RAG flow.',
  },
];

const ServicesPage: React.FC = () => {
  useDocumentMetadata(
    'Services',
    'Explore the healthcare features available in MediInsight AI.'
  );

  return (
    <div className="min-h-screen bg-slate-50 py-12">
      <div className="container mx-auto max-w-6xl px-6">
        <div className="mb-10 text-center">
          <h1 className="text-4xl font-bold text-slate-900">Platform Services</h1>
          <p className="mt-4 text-lg text-slate-600">
            Each module is designed to showcase a different healthcare workflow while staying cohesive as a single product.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          {services.map((service) => (
            <div key={service.title} className="rounded-3xl bg-white p-8 shadow-sm ring-1 ring-slate-200">
              <div className="flex items-center gap-3">
                {service.icon}
                <h2 className="text-2xl font-semibold text-slate-900">{service.title}</h2>
              </div>
              <p className="mt-4 text-slate-600">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;
